import React, { lazy } from 'react';

const FormEditAdmin = lazy(
  () => import('../Forms/AdminForms/FormEditAdmin.page.jsx')
);
const Admin = lazy(() => import('../AdminRoutes/Admin/AdminHome.page.jsx'));
const CreateUser = lazy(
  () => import('../AdminRoutes/CreateRoutes/CreateUser/UserCreate.page.jsx')
);
const CreateCompany = lazy(
  () =>
    import('../AdminRoutes/CreateRoutes/CreateCompany/CompanyCreate.page.jsx')
);
const CreateCourse = lazy(
  () => import('../AdminRoutes/CreateRoutes/CreateCourse/CourseCreate.page.jsx')
);
// const CreateProduct = lazy(
//   () =>
//     import('../AdminRoutes/CreateRoutes/CreateProduct/CreateProduct.page.jsx')
// );
const CreateNewsletter = lazy(
  () =>
    import(
      '../AdminRoutes/CreateRoutes/CreateNewsletter/NewsletterCreate.page.jsx'
    )
);
const CreateEmpMan = lazy(
  () => import('../AdminRoutes/CreateRoutes/CreateEmpMan/CreateEmpMan.page.jsx')
);
const EditCourse = lazy(
  () => import('../AdminRoutes/EditRoutes/EditCourse/CourseEdit.page.jsx')
);
const EditCompany = lazy(
  () => import('../AdminRoutes/EditRoutes/EditCompany/CompanyEdit.page.jsx')
);
const EditManagersAndUsers = lazy(
  () => import('../AdminRoutes/EditRoutes/EditManagers/ManagersEdit.page.jsx')
);
const EditNewsletter = lazy(
  () => import('../AdminRoutes/EditRoutes/EditNewsletter/NewsEdit.page.jsx')
);
const UsersTab = lazy(
  () => import('../AdminRoutes/Admin/Users/UserTabComponent.page.jsx')
);
const UserDetailsBasePage = lazy(
  () => import('../UserDetails/UserDetails.page.jsx')
);
const CompanyAdminHome = lazy(
  () =>
    import(
      '../AdminRoutes/Admin/Companies/CompaniesHome/CompanyHomepage.page.jsx'
    )
);
const CompaniesTab = lazy(
  () => import('../AdminRoutes/Admin/Companies/CompaniesTabComponent.page.jsx')
);
const CoursesTab = lazy(
  () => import('../AdminRoutes/Admin/Courses/CoursesTabComponent.page.jsx')
);
const NewslettersSubscribersList = lazy(
  () => import('../AdminRoutes/Admin/NewsletterSubscribers.page.jsx')
);
const NewsletterTab = lazy(
  () => import('../AdminRoutes/Admin/Newsletters/NewsletterTab.page.jsx')
);
const DiscountHomepage = lazy(
  () =>
    import(
      '../AdminRoutes/CreateRoutes/CreateDiscount/DiscountHomepage.page.jsx'
    )
);
const PurchaseHistoryAdmin = lazy(
  () =>
    import('../AdminRoutes/Admin/Companies/Purchases/PurchaseHistory.page.jsx')
);
const GetInfo = lazy(
  () => import('../AdminRoutes/GetInformation/GetInfo.page.jsx')
);
const CreateImage = lazy(
  () => import('../AdminRoutes/CreateRoutes/CreateImage/CreateImage.page.jsx')
);
const EmailTesting = lazy(
  () => import('../AdminRoutes/EmailTesting/EmailTesting.page.jsx')
);
const FormHomepageAdmin = lazy(
  () => import('../Forms/AdminForms/FormHomepageAdmin.page.jsx')
);
const FormsAndManuals = lazy(
  () => import('../AdminRoutes/FormsAndManuals/FormsAndManuals.page.jsx')
);
const FormAndManualsView = lazy(
  () => import('../AdminRoutes/FormsAndManuals/FormAndManualsView.page.jsx')
);
const FeedbackPage = lazy(
  () => import('../AdminRoutes/Feedback/Feedback.page.jsx')
);
const Subscriptions = lazy(
  () =>
    import(
      '../AdminRoutes/Admin/Companies/Subscriptions/Subscriptions.page.jsx'
    )
);
// const EditProduct = lazy(
//   () => import('../AdminRoutes/EditRoutes/EditProduct/EditProduct.page.jsx')
// );
// import ProvinceHomepage from '../AdminRoutes/Admin/Companies/Provinces/Province.component.jsx';
// import ProvincesList from '../AdminRoutes/Admin/Companies/Provinces/ProvincesList.component.jsx';
// const CreateProvince = lazy(
//   () =>
//     import(
//       '../AdminRoutes/CreateRoutes/CreateProvince/ProvinceCreate.component.jsx'
//     )
// );

export const adminRoutes = [
  { path: '', element: <Admin /> },
  { path: 'create-course', element: <CreateCourse /> },
  { path: 'create-company', element: <CreateCompany /> },
  { path: 'create-user', element: <CreateUser /> },
  // { path: 'create-product', element: <CreateProduct /> },
  { path: 'create-image', element: <CreateImage /> },
  { path: 'information', element: <GetInfo /> },
  { path: 'discounts', element: <DiscountHomepage /> },
  { path: 'newsletter-subscribers', element: <NewslettersSubscribersList /> },
  { path: 'create-newsletter', element: <CreateNewsletter /> },
  { path: 'edit-user/:id', element: <UserDetailsBasePage /> },
  { path: 'company/purchase-history/:id', element: <PurchaseHistoryAdmin /> },
  { path: 'edit-newsletter/:id', element: <EditNewsletter /> },
  { path: 'edit-course/:id', element: <EditCourse /> },
  // { path: 'edit-product/:id', element: <EditProduct /> },
  { path: 'company/employees/:id', element: <EditManagersAndUsers /> },
  { path: 'company/employees/create/:id', element: <CreateEmpMan /> },
  { path: 'company/edit/:id', element: <EditCompany /> },
  { path: 'company-home/:id', element: <CompanyAdminHome /> },
  { path: 'courses', element: <CoursesTab /> },
  { path: 'companies', element: <CompaniesTab /> },
  { path: 'users', element: <UsersTab /> },
  { path: 'newsletters', element: <NewsletterTab /> },
  { path: 'email-testing', element: <EmailTesting /> },
  { path: 'forms/without-fillins', element: <FormHomepageAdmin /> },
  { path: 'forms/edit', element: <FormEditAdmin /> },
  { path: 'forms-and-manuals/upload/:id', element: <FormsAndManuals /> },
  { path: 'forms-and-manuals/view/:id', element: <FormAndManualsView /> },
  { path: 'feedback', element: <FeedbackPage /> },
  { path: 'subscriptions/:id', element: <Subscriptions /> },
  // { path: 'provinces/:id', element: <ProvincesList /> },
  // { path: 'province/:id', element: <ProvinceHomepage /> },
  // { path: 'provinces/create/:id', element: <CreateProvince /> },
  // { path: 'forms/without-/fillins', element: <AdminTool /> },
];

// Remember to wrap your <Routes> in <Suspense fallback={...}> in your router!
